// Global CTA targets used across the site.
// Keep these in one place so the "Book a call" and "Contact us" actions
// always route to the same destinations.

export const BOOK_A_CALL_URL =
  "https://app.usemotion.com/meet/bensroom/zoom-discovery";

/**
 * Scrolls to the on-page contact form.
 * Homepage uses id="conversation"; sub-pages use id="page-contact" (PageCTA).
 * Falls back to navigating to the homepage form if none is found.
 */
export function scrollToContactForm(): void {
  if (typeof document === "undefined") return;
  const el =
    document.getElementById("page-contact") ??
    document.getElementById("conversation") ??
    document.getElementById("contact");
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  } else {
    window.location.href = "/#conversation";
  }
}
